export type { RichTextAreaWrapperProps } from './styled';
export { getRichTextAreaWrapperStyles } from './styled';
export { getRichTextAreaWrapperStylesWithDarkerBorder } from './rich-text-area-wrapper';
